import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './api/setupApiClient';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);

// Hide global loader once the app has mounted
const globalLoader = document.getElementById('global-loader');
if (globalLoader) {
    globalLoader.classList.remove('active');
}

// Register service worker for PWA
serviceWorkerRegistration.register();
